import {
  BarChart,
  BuildingIcon,
  DollarSignIcon,
  LandPlotIcon,
  ListTodoIcon,
  LucideIcon,
  MapPinnedIcon,
  PackageIcon,
  PieChartIcon,
  PlugIcon,
  ScrollTextIcon,
  ShoppingBasketIcon,
  UsersIcon,
} from "lucide-react";

import {
  isCompanyEmployee,
  isCompanyMaster,
  isMaster,
} from "@/lib/auth-utilts";

import { HelmetIcon } from "../helmet-icon";

const sidebarNavigation = [
  {
    title: "Administração",
    url: "#",

    items: [
      {
        icon: UsersIcon,
        title: "Usuários",
        url: "/dashboard/users",
        canAccess: isMaster,
      },

      {
        icon: ListTodoIcon,
        title: "Planos",
        url: "/dashboard/plans",
        canAccess: isMaster,
      },

      {
        icon: MapPinnedIcon,
        title: "Bairros",
        url: "/dashboard/neighborhoods",
        canAccess: isMaster,
      },

      {
        icon: LandPlotIcon,
        title: "Regiões",
        url: "/dashboard/regions",
        canAccess: isMaster,
      },

      {
        icon: BuildingIcon,
        title: "Empresas",
        url: "/dashboard/companies",
        canAccess: isMaster,
      },

      {
        icon: HelmetIcon,
        title: "Entregadores",
        url: "/dashboard/deliverymans",
        canAccess: isMaster,
      },

      {
        icon: PieChartIcon,
        title: "Estatísticas",
        url: "/dashboard/stats",
        canAccess: isMaster,
      },

      {
        icon: DollarSignIcon,
        title: "Dinâmicas",
        url: "/dashboard/dynamics",
        canAccess: isMaster,
      },

      {
        icon: ScrollTextIcon,
        title: "Contratos",
        url: "/dashboard/contracts",
        canAccess: isMaster,
      },
    ],
  },

  {
    title: "Gestão",
    url: "#",

    items: [
      {
        icon: ShoppingBasketIcon,
        title: "Entregas",
        url: "/dashboard/deliveries",
        canAccess: () => {
          return isMaster() || isCompanyMaster() || isCompanyEmployee();
        },
      },

      {
        icon: PlugIcon,
        title: "Integrações",
        url: "/dashboard/integrations",
        featureFlag: "integrations-page",
        canAccess: () => {
          return isCompanyMaster() || isCompanyEmployee();
        },
      },
    ],
  },

  {
    title: "Dados",
    url: "#",

    items: [
      {
        icon: BarChart,
        title: "Relatórios",
        url: "/dashboard/reports",
        canAccess: () => {
          return isMaster() || isCompanyMaster();
        },
      },

      {
        icon: PieChartIcon,
        title: "Métricas",
        url: "/dashboard/metrics",
        canAccess: () => {
          return isMaster() || isCompanyMaster();
        },
      },
    ],
  },
] as SidebarGroup[];

export function getSidebarNavigation(
  isFeatureFlagEnabled: (flag: string) => boolean,
) {
  return sidebarNavigation
    .map((group) => {
      const items = group.items.filter((item) => {
        if (item.featureFlag && !isFeatureFlagEnabled(item.featureFlag)) {
          return false;
        }

        return item.canAccess ? item.canAccess() : true;
      });

      return {
        ...group,
        items,
      };
    })
    .filter((group) => group.items.length > 0);
}

export type SidebarGroup = {
  title: string;
  url: string;
  items: SidebarItem[];
};

export type SidebarItem = {
  icon: LucideIcon | typeof HelmetIcon;
  title: string;
  url?: string;
  onClick?: () => void;
  canAccess?: () => boolean;
  featureFlag?: string;
  requiresConfirmation?: boolean;
};
